import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAgreementsUrl } from '@/utils/useAgreementsUrl';
import HelpSection from './HelpSection';
import TrustpilotWidget from './TrustpilotWidget';

const Footer = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const year = new Date().getFullYear();
  const { privacyLink, termsOfUseLink } = useAgreementsUrl();
  const showFooter = !pathname.includes('build-offer');

  return showFooter ? (
    <div className="mx-auto mb-10 max-w-screen-2xl px-4 lg:mt-10 lg:px-6">
      <div className="mx-4 lg:mx-8">
        <HelpSection />
        <div className="mt-10 text-xs">
          <div className="space-x-2 text-center">
            <span className="inline">{t('core.legalCopyright', { year })}</span>
            <span className="inline-block">|</span>
            <a className="inline-block text-blue-500" rel="noreferrer" target="_blank" href={privacyLink}>
              {t('core.privacyPolicy')}
            </a>
            <span className="inline-block">|</span>
            <a className="inline-block text-blue-500" rel="noreferrer" target="_blank" href={termsOfUseLink}>
              {t('footer.termsOfUseLinkText')}
            </a>
          </div>
          <div className="mt-2">
            <TrustpilotWidget />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default Footer;
